import {
  Col,
  useModal,
  Workflow,
  WorkflowButton,
} from '@xbto/universal-components';
import { useCallback } from 'react';
import { StyleSheet } from 'react-native';

type Args = {
  canBuy: boolean;
  canSell: boolean;
  canSend: boolean;
  canReceive: boolean;
  canTransfer: boolean;
  canAddCash: boolean;
  canWithdrawCash: boolean;
  onPressWorkflow: (name: Workflow) => void;
};

export const useWorkflowSelector = ({
  canBuy,
  canSell,
  canSend,
  canReceive,
  canTransfer,
  canAddCash,
  canWithdrawCash,
  onPressWorkflow,
}: Args) => {
  /**
   * Hooks
   */
  const { open: openModal, Modal, close: closeModal } = useModal();

  /**
   * Methods
   */
  const handlePressItem = useCallback(
    (name: Workflow) => {
      closeModal();
      onPressWorkflow(name);
    },
    [onPressWorkflow, closeModal]
  );
  const open = useCallback(() => {
    openModal({
      title: 'What would you like to do?',
      Body: (
        <Col style={$.container}>
          <WorkflowButton name={Workflow.Funds} onPress={handlePressItem} />
          {canBuy && (
            <WorkflowButton name={Workflow.Buy} onPress={handlePressItem} />
          )}
          {canSell && (
            <WorkflowButton name={Workflow.Sell} onPress={handlePressItem} />
          )}
          {canTransfer && (
            <WorkflowButton
              name={Workflow.Transfer}
              onPress={handlePressItem}
            />
          )}
          {canSend && (
            <WorkflowButton name={Workflow.Send} onPress={handlePressItem} />
          )}
          {canReceive && (
            <WorkflowButton name={Workflow.Receive} onPress={handlePressItem} />
          )}
          {canWithdrawCash && (
            <WorkflowButton
              name={Workflow.WithdrawCash}
              onPress={handlePressItem}
            />
          )}
          {canAddCash && (
            <WorkflowButton name={Workflow.AddCash} onPress={handlePressItem} />
          )}
        </Col>
      ),
    });
  }, [
    openModal,
    handlePressItem,
    canBuy,
    canSell,
    canTransfer,
    canSend,
    canReceive,
    canWithdrawCash,
    canAddCash,
  ]);

  /**
   * Result
   */
  return {
    open,
    Selector: Modal,
  };
};

const $ = StyleSheet.create({
  container: {
    rowGap: 8,
  },
});
